module.exports = __webpack_public_path__ + "img/2.de232bb2.png";